import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { ApiErrorResponse } from 'src/app/common/network';
import { useDispatch } from 'react-redux';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../../common/constants';
import { LayoutSplashScreen } from 'src/app/layout';
import { ApplicationFormMode, ApplicationDetail } from '../../types/application-types';
import { fetchApplicationItem } from '../../network/applicationCrud';
import ApplicationDetailForm from './components/ApplicationDetailForm';

const ApplicationDetailPage: FC<RouteComponentProps> = ({ history, location }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode } = useMemo(
    () => ({
      formMode: id ? ApplicationFormMode.EDIT : ApplicationFormMode.CREATE,
    }),
    [id],
  );

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [appliactionDetail, setApplicationDetail] = useState<ApplicationDetail>();

  const reloadData = () => {
    if (id) {
      setIsLoading(true);
      fetchApplicationItem(id, dispatch)
        .then((result) => {
          setApplicationDetail(result);
        })
        .catch((err: ApiErrorResponse) => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [id]);

  return (
    <>
      {formMode === ApplicationFormMode.CREATE && <ApplicationDetailForm formMode={formMode} />}
      {formMode === ApplicationFormMode.EDIT &&
        (isLoading || !appliactionDetail ? (
          <LayoutSplashScreen />
        ) : (
          <ApplicationDetailForm formMode={formMode} applicationDetail={appliactionDetail} />
        ))}
    </>
  );
};

export default ApplicationDetailPage;
